import Rest from './rest';

const RESOURCE = "/a/asset";

export default {
    upload(data) {
        return Rest.post(RESOURCE, data);
    },
};



// WEBPACK FOOTER //
// ./src/services/AssetService.js